import React from 'react';
import { BsChevronDoubleRight, BsChevronRight } from 'react-icons/bs';
import { Flex, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function ForwardIconGroup({ getForwardProps, calendars }) {
  return (
    <Flex>
      <Tooltip hasArrow label="Next month">
        <IconButton
          {...getForwardProps({ calendars })}
          icon={<Icon as={BsChevronRight} />}
          variant="textPrimary"
        />
      </Tooltip>
      <Tooltip hasArrow label="Next year">
        <IconButton
          {...getForwardProps({ calendars, offset: 12 })}
          icon={<Icon as={BsChevronDoubleRight} />}
          variant="textPrimary"
        />
      </Tooltip>
    </Flex>
  );
}

ForwardIconGroup.propTypes = {
  getForwardProps: PropTypes.func,
  calendars: PropTypes.arrayOf(PropTypes.shape({}))
};

export default ForwardIconGroup;
